var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isBlank)?_c('el-form-item',{attrs:{"label":_vm.label}},[_c('el-col',{attrs:{"lg":11,"md":16,"sm":24}},[_c('app-image-carousel',{attrs:{"value":_vm.value}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }